import { createAction, props } from '@ngrx/store';

import { DashboardBrokerNorwayActionTypes } from './actions.model';

export const init = createAction(DashboardBrokerNorwayActionTypes.Init);

export const tabIndexChanged = createAction(
  DashboardBrokerNorwayActionTypes.TabIndexChanged,
  props<{ key: string }>()
);

export const enquiriesFilterChanged = createAction(
  DashboardBrokerNorwayActionTypes.EnquiriesFilterChanged,
  props<{ filter: Record<string, any> }>()
);

export const cancellationsFilterChanged = createAction(
  DashboardBrokerNorwayActionTypes.CancellationsFilterChanged,
  props<{ filter: Record<string, any> }>()
);
